import React, { useContext } from 'react';
import AvatarImage from "../avatar/AvatarImage";
import { AvatarDefaultProps, BADGE_PHOTO_URL } from "../avatar/avatarConstants";
import { StencilContext } from "../context";
import { Row } from "../layout";
import { Text } from "../text";
import { getUniqueId } from "../utils";
import ChipAvatarLink from "./ChipAvatarLink";
import ChipDismissButton from "./ChipDismissButton";
import { CHIP_CONTENT_GAP, AVATAR_USERNAME_GAP } from "./constants";
import { ChipSize, ChipIconPosition, ChipColorScheme, ChipBackgroundColor } from "./interfaces";
import useChipStyle from "./useChipStyle";
import { jsx as ___EmotionJSX } from "@emotion/core";

var ChipBase = function ChipBase(props) {
  var avatar = props.avatar,
      children = props.children,
      _props$size = props.size,
      size = _props$size === void 0 ? ChipSize.Default : _props$size,
      icon = props.icon,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? ChipIconPosition.Leading : _props$iconPosition,
      onClick = props.onClick,
      onDismiss = props.onDismiss,
      _props$colorScheme = props.colorScheme,
      colorScheme = _props$colorScheme === void 0 ? ChipColorScheme.Default : _props$colorScheme,
      dismissButtonRef = props.dismissButtonRef,
      _props$dismissButtonA = props.dismissButtonAltText,
      dismissButtonAltText = _props$dismissButtonA === void 0 ? 'Remove' : _props$dismissButtonA,
      _props$backgroundColo = props.backgroundColor,
      backgroundColorProp = _props$backgroundColo === void 0 ? ChipBackgroundColor.Default : _props$backgroundColo;

  var _useContext = useContext(StencilContext),
      selectors = _useContext.selectors;

  var chipId = "chip-".concat(getUniqueId(), "-id");
  var isDismissible = typeof onDismiss === 'function';
  var asAvatar = Boolean(avatar);

  var _useChipStyle = useChipStyle({
    size: size,
    icon: icon,
    iconPosition: iconPosition,
    colorScheme: colorScheme,
    backgroundColor: backgroundColorProp,
    asAvatar: asAvatar,
    isDismissible: isDismissible
  }),
      containerPadding = _useChipStyle.containerPadding,
      avatarImageSize = _useChipStyle.avatarImageSize,
      fontSize = _useChipStyle.fontSize,
      hasLeadingIcon = _useChipStyle.hasLeadingIcon,
      hasTrailingIcon = _useChipStyle.hasTrailingIcon;

  var avatarImageSource = avatar ? "".concat(BADGE_PHOTO_URL, "?uid=").concat(avatar.username) : '';
  return ___EmotionJSX(Row, {
    alignItems: "center",
    width: "max-content",
    maxWidth: "100%",
    height: "100%",
    gridGap: CHIP_CONTENT_GAP,
    padding: containerPadding
  }, avatar && ___EmotionJSX(AvatarImage, {
    selectors: selectors,
    size: avatarImageSize,
    source: avatarImageSource,
    shouldAnnounceImageAltText: false,
    marginRight: 0
  }), !avatar && hasLeadingIcon && icon, ___EmotionJSX(Row, {
    alignItems: "center",
    gridGap: AVATAR_USERNAME_GAP
  }, ___EmotionJSX(Text, {
    fontSize: fontSize,
    id: isDismissible ? chipId : undefined
  }, avatar ? "".concat(avatar.fullName, " ") : children), avatar && ___EmotionJSX(ChipAvatarLink, {
    username: avatar.username,
    newTabHiddenText: avatar.newTabHiddenText || AvatarDefaultProps.newTabHiddenText,
    fontSize: fontSize,
    colorScheme: colorScheme,
    isClickable: avatar.isUsernameClickable
  })), !avatar && !isDismissible && hasTrailingIcon && icon, onDismiss && !onClick && ___EmotionJSX(ChipDismissButton, {
    chipId: chipId,
    dismissButtonRef: dismissButtonRef,
    dismissButtonAltText: dismissButtonAltText,
    onDismiss: onDismiss,
    colorScheme: colorScheme
  }));
};

export default ChipBase;